import { render, staticRenderFns } from "./studentQestion.vue?vue&type=template&id=914f4e1c&scoped=true"
import script from "./studentQestion.vue?vue&type=script&lang=js"
export * from "./studentQestion.vue?vue&type=script&lang=js"
import style0 from "./studentQestion.vue?vue&type=style&index=0&id=914f4e1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "914f4e1c",
  null
  
)

export default component.exports